import gql from 'graphql-tag';

export const createTenant = gql`
  mutation CreateTenant($tenantId: UUID!, $propertyId: UUID!) {
    createTenant(tenantId: $tenantId, propertyId: $propertyId)
  }
`;
